import { Point } from 'geojson';

import { SnGoogleGeocoderAddressComponents } from '@lib/geo/google/geocoder';
import { fromGoogleMapLatLng, fromGoogleMapLatLngBounds } from '@lib/geo/google/map';
import { SnLonLat, SnLonLatBounds } from '@lib/geo/helpers';

export class GooglePlaceResult {
  public id: string;
  public name: string;
  public formattedAddress: string;
  public addressComponents: SnGoogleGeocoderAddressComponents;

  public lonLat: SnLonLat;
  public latLngBounds: SnLonLatBounds;
  public geometry: Point;

  constructor(data: google.maps.places.PlaceResult) {
    this.id = data.place_id;
    this.name = data.name;
    this.formattedAddress = data.formatted_address;
    this.addressComponents = new SnGoogleGeocoderAddressComponents(data.address_components);

    this._decodeGeometry(data.geometry);
  }

  private _decodeGeometry(geometry: google.maps.places.PlaceGeometry): void {
    this.lonLat = fromGoogleMapLatLng(geometry.location);
    this.geometry = this.lonLat.toGeojsonPoint();

    if (geometry.viewport) {
      this.latLngBounds = fromGoogleMapLatLngBounds(geometry.viewport);
    }
  }
}
